import React from 'react';
import clsx from 'clsx';
import {useTranslation} from 'react-i18next';
import useReactiveMessage from '../../hook/UseReactiveMessage';

const CatalogPartnerCard = (props) => {

  let {
    documentId,
    available,
    status
  } = props;

  const {sendMessage} = useReactiveMessage('CATALOG_PARTNER');
  const {t} = useTranslation(['catalog']);

  const isButtonDisabled = () => {
    let disabled = false;
    if(status === 7 || !available) {
      disabled = true;
    }
    return disabled;
  };

  const onClick = () => {
    if (!isButtonDisabled()) {
      sendMessage({
        documentId
      })
    }
  };

  return (
    <React.Fragment>
      <div className="aw-inquiry-card" id="catalog-partner-card">
        <p className="title mb-4">{ t('catalog.partner.title') }</p>
        <p className="mb-4">{ t('catalog.partner.description') }</p>
        <a className={clsx("btn btn-default btn-xl btn-block text-wrap partnerCatalog",{disabled: isButtonDisabled()})} href="#" onClick={onClick}>
          { t('catalog.partner.button') }
        </a>
        { status === 7 &&
          <p className="text-danger text-center">既に申請済です</p>
        }
      </div>
    </React.Fragment>
  )

};

export default CatalogPartnerCard;

